import { getBoolean, getString, type RemoteConfig } from 'firebase/remote-config';
import { isWithinServiceHours } from '../utils/isWithinServiceHours';
import { parseSchedule } from '../utils';

export function useRemoteConfig(remoteConfig: RemoteConfig) {

  const showBuyBalancePage = getBoolean(remoteConfig, 'show_buy_balance_page');
  const defaultSchedule = remoteConfig.defaultConfig.schedule as string;
  const schedule = parseSchedule(getString(remoteConfig, 'schedule'), defaultSchedule);

  return {
    showBuyBalancePage,
    schedule,
    isWithinServiceHours: isWithinServiceHours(schedule, new Date())
  };  
}
